const API_BASE = '';

export const getSession = () => (
    fetch(`${API_BASE}/api/session`, {
        method: 'GET',
        credentials: 'include'
    }).then(response => response.json())
);

export const login = ({username, password}) => (
    fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({username, password})
    }).then(async response => {
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || 'LOGIN_FAILED');
        }
        return data;
    })
);

export const logout = () => (
    fetch(`${API_BASE}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
    }).then(response => response.json())
);